
import { LucideIcon } from "lucide-react";
import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: ReactNode;
  action?: ReactNode;
  className?: string;
  iconClassName?: string;
  iconSize?: number;
  align?: "center" | "left";
}

const EmptyState = ({ 
  icon: Icon, 
  title, 
  description, 
  action, 
  className,
  iconClassName,
  iconSize = 24,
  align = "center"
}: EmptyStateProps) => {
  return (
    <div className={cn(
      "flex flex-col py-12",
      align === "center" ? "items-center justify-center text-center" : "items-start justify-start text-left",
      className
    )}>
      <div className={cn("bg-muted rounded-full p-4 mb-4", iconClassName)}>
        <Icon className={cn("text-muted-foreground", `h-${iconSize/6} w-${iconSize/6}`)} size={iconSize} />
      </div>
      <h3 className="text-lg font-medium mb-2">{title}</h3>
      <p className={cn("text-muted-foreground", align === "center" ? "max-w-md" : "max-w-full")}>
        {description}
      </p>
      {action && (
        <div className="mt-6">
          {action}
        </div>
      )}
    </div>
  );
};

export { EmptyState };
